// SourceBarList.tsx (CONFIRMED/FIXED for visual order)
import React from 'react';
import { CustomConfig } from './types'; // Assuming CustomConfig is available

interface SourceBarProps {
    source: string;
    leads: number;
    maxLeads: number;
}

const SourceBar: React.FC<SourceBarProps> = ({ source, leads, maxLeads }) => {
    const percentage = (leads / maxLeads) * 100;

    return (
        <div className="flex items-center justify-between my-3">
            {/* Label (Source) */}
            <div className="w-1/3 text-gray-700 text-sm">{source}</div>

            {/* Bar */}
            <div className="w-1/2 bg-gray-200 rounded-full h-2.5 relative">
                <div
                    className="bg-blue-500 h-2.5 rounded-full"
                    style={{ width: `${percentage}%` }}
                />
            </div>

            {/* Value (Leads) */}
            <div className="w-1/6 text-right font-medium text-gray-800">{leads}</div>
        </div>
    );
};

const SourceBarList: React.FC<{ config: CustomConfig }> = ({ config }) => {
    const maxLeads = Math.max(...config.data.map(d => d.leads));

    // 🔑 FIX/CONFIRMATION: Sort data ASCENDING to display LOWEST value at the top 
    // and HIGHEST value at the bottom, matching the visual design.
    const sortedData = [...config.data].sort((a, b) => a.leads - b.leads);

    return (
        <div className="p-4">
            {sortedData.map((d) => (
                <SourceBar
                    key={d.source}
                    source={d.source}
                    leads={d.leads}
                    maxLeads={maxLeads}
                />
            ))}
        </div>
    );
};

export default SourceBarList;